import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Oui } from '../models/Oui';
import { Step2 } from '../../../../shared/models/component-messages/blocCommun/simp/step2';

@Component({
  selector: 'app-oui',
  templateUrl: './oui.component.html'
})
export class OuiComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Oui'
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  
  	@Input() oui : Oui;

    public step2 = new Step2();

  constructor() { 
    if (!this.oui) {
      this.oui = new Oui();
    }
  }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

